var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("mandate.payment_schedule_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                {
                  staticClass:
                    "min-w-100 justify-content-start align-items-center",
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-start mt-3",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2 mr-2",
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "back-button btnFilter_2",
                          on: {
                            click: function ($event) {
                              return _vm.getPaymentSchedule()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-solid fa-rotate-right" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.listItemsPaymentSchedule.length > 0
                ? [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "mt-3", attrs: { cols: "12" } },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.mandate_info"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.unique_mandate_rf"
                                                ),
                                                inputValue:
                                                  _vm
                                                    .listItemsPaymentSchedule[0]
                                                    .UMR || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.dbtr"),
                                                inputValue:
                                                  _vm
                                                    .listItemsPaymentSchedule[0]
                                                    .debtor || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.cdtr_info"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            !_vm.editMode
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    tag: "component",
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "mandate.cdtr_iban"
                                                        ),
                                                      inputValue:
                                                        _vm
                                                          .listItemsPaymentSchedule[0]
                                                          .CdtrIBAN || "-",
                                                    },
                                                  }
                                                )
                                              : _c(
                                                  "form-write-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "mandate.cdtr_iban"
                                                        ),
                                                      placeholderValue:
                                                        _vm.$t(
                                                          "mandate.cdtr_iban"
                                                        ),
                                                      isMandatory: "",
                                                      maxLength: 27,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .listItemsPaymentSchedule[0]
                                                          .CdtrIBAN,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm
                                                            .listItemsPaymentSchedule[0],
                                                          "CdtrIBAN",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "listItemsPaymentSchedule[0].CdtrIBAN",
                                                    },
                                                  }
                                                ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "mandate.payment_schedule_details"
                                      ),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.status_collection"
                                                ),
                                                inputValue:
                                                  _vm.$t(
                                                    "mandate.status_payment_schedule_" +
                                                      _vm
                                                        .listItemsPaymentSchedule[0]
                                                        .status
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c(
                                              _vm.editMode
                                                ? "form-write-group-label-input"
                                                : "form-read-group-label-input",
                                              {
                                                tag: "component",
                                                attrs: {
                                                  inputLabel:
                                                    _vm.$t("mandate.rsn_debit"),
                                                  inputValue:
                                                    _vm
                                                      .listItemsPaymentSchedule[0]
                                                      .reason || "-",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .listItemsPaymentSchedule[0]
                                                      .reason,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm
                                                        .listItemsPaymentSchedule[0],
                                                      "reason",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "listItemsPaymentSchedule[0].reason",
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            !_vm.editMode
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    tag: "component",
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "mandate.frequency_type"
                                                      ),
                                                      inputValue:
                                                        _vm.$t(
                                                          "mandate.frequency_type_" +
                                                            _vm
                                                              .listItemsPaymentSchedule[0]
                                                              .frequency
                                                        ) || "-",
                                                    },
                                                  }
                                                )
                                              : _c("div", [
                                                  _c("label", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.frequency_type"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .listItemsPaymentSchedule[0]
                                                              .frequency,
                                                          expression:
                                                            "listItemsPaymentSchedule[0].frequency",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm
                                                              .listItemsPaymentSchedule[0],
                                                            "frequency",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "",
                                                            disabled: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.frequency_type_select"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.FrequencyTypeList,
                                                        function (p) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key: p.value,
                                                              domProps: {
                                                                value: p.value,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      p.label
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === "1" ||
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === 1
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  _vm.editMode
                                                    ? "form-write-group-label-input"
                                                    : "form-read-group-label-input",
                                                  {
                                                    tag: "component",
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t("mandate.amt"),
                                                      inputValue:
                                                        _vm.formatCurrency(
                                                          _vm
                                                            .listItemsPaymentSchedule[0]
                                                            .amountR
                                                        ) || "-",
                                                      isMandatory: _vm.editMode,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .listItemsPaymentSchedule[0]
                                                          .amountR,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm
                                                            .listItemsPaymentSchedule[0],
                                                          "amountR",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "listItemsPaymentSchedule[0].amountR",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === "1" ||
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === 1
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                !_vm.editMode
                                                  ? _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        tag: "component",
                                                        attrs: {
                                                          inputLabel: _vm.$t(
                                                            "mandate.date_first_debit"
                                                          ),
                                                          inputValue:
                                                            _vm.formatDate(
                                                              _vm
                                                                .listItemsPaymentSchedule[0]
                                                                .firstDebitateDate
                                                            ) || "-",
                                                        },
                                                      }
                                                    )
                                                  : _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "filter-item-title d-block mb-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.date_first_debit"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color: "red",
                                                                },
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "datetime-picker-custom",
                                                          {
                                                            staticClass: "mr-3",
                                                            class: {
                                                              "filter-item-input": true,
                                                              "filter-item-input-complete":
                                                                _vm
                                                                  .listItemsPaymentSchedule[0]
                                                                  .firstDebitateDate,
                                                            },
                                                            staticStyle: {
                                                              padding:
                                                                "0.35rem",
                                                            },
                                                            attrs: {
                                                              format:
                                                                "YYYY-MM-DD",
                                                              periodFull: "",
                                                              id: "filter-date-end",
                                                              customInputParentClass:
                                                                "filter-item-content",
                                                              customInputClass:
                                                                "w-100",
                                                              maxLength: 19,
                                                              placeholderValue:
                                                                _vm.$t(
                                                                  "common.datepicker_format_date3"
                                                                ),
                                                              inputIcon:
                                                                "fa-solid fa-calendar",
                                                              disablePastDates:
                                                                "",
                                                              showTime: false,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .listItemsPaymentSchedule[0]
                                                                  .firstDebitateDate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .listItemsPaymentSchedule[0],
                                                                    "firstDebitateDate",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "listItemsPaymentSchedule[0].firstDebitateDate",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === "1" ||
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === 1
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                !_vm.editMode
                                                  ? _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        tag: "component",
                                                        attrs: {
                                                          inputLabel: _vm.$t(
                                                            "mandate.periodicity"
                                                          ),
                                                          inputValue:
                                                            _vm
                                                              .listItemsPaymentSchedule[0]
                                                              .periodicity ||
                                                            "-",
                                                        },
                                                      }
                                                    )
                                                  : _c("div", [
                                                      _c("label", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.periodicity"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("*")]
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .listItemsPaymentSchedule[0]
                                                                  .periodicity,
                                                              expression:
                                                                "listItemsPaymentSchedule[0].periodicity",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.$set(
                                                                _vm
                                                                  .listItemsPaymentSchedule[0],
                                                                "periodicity",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "",
                                                                disabled: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.periodicity_select"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.periodicityList,
                                                            function (p) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: p.value,
                                                                  domProps: {
                                                                    value:
                                                                      p.value,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          p.label
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === "1" ||
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === 1
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  _vm.editMode
                                                    ? "form-write-group-label-input"
                                                    : "form-read-group-label-input",
                                                  {
                                                    tag: "component",
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "mandate.nb_occurences"
                                                      ),
                                                      inputValue:
                                                        _vm
                                                          .listItemsPaymentSchedule[0]
                                                          .nbOccurence || "-",
                                                      type: "number",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .listItemsPaymentSchedule[0]
                                                          .nbOccurence,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm
                                                            .listItemsPaymentSchedule[0],
                                                          "nbOccurence",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "listItemsPaymentSchedule[0].nbOccurence",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === "1" ||
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency === 1
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                !_vm.editMode
                                                  ? _c(
                                                      "form-read-group-label-input",
                                                      {
                                                        tag: "component",
                                                        attrs: {
                                                          inputLabel:
                                                            _vm.$t(
                                                              "mandate.date_end"
                                                            ),
                                                          inputValue:
                                                            _vm.formatDate(
                                                              _vm
                                                                .listItemsPaymentSchedule[0]
                                                                .endDate
                                                            ) || "-",
                                                        },
                                                      }
                                                    )
                                                  : _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "filter-item-title d-block mb-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.date_end"
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "datetime-picker-custom",
                                                          {
                                                            staticClass: "mr-3",
                                                            class: {
                                                              "filter-item-input": true,
                                                              "filter-item-input-complete":
                                                                _vm
                                                                  .listItemsPaymentSchedule[0]
                                                                  .endDate,
                                                            },
                                                            staticStyle: {
                                                              padding:
                                                                "0.35rem",
                                                            },
                                                            attrs: {
                                                              format:
                                                                "YYYY-MM-DD",
                                                              periodFull: "",
                                                              id: "filter-date-end",
                                                              customInputParentClass:
                                                                "filter-item-content",
                                                              customInputClass:
                                                                "w-100",
                                                              maxLength: 19,
                                                              placeholderValue:
                                                                _vm.$t(
                                                                  "common.datepicker_format_date3"
                                                                ),
                                                              inputIcon:
                                                                "fa-solid fa-calendar",
                                                              disablePastDates:
                                                                "",
                                                              showTime: false,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .listItemsPaymentSchedule[0]
                                                                  .endDate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .listItemsPaymentSchedule[0],
                                                                    "endDate",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "listItemsPaymentSchedule[0].endDate",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.date_due_next"
                                                ),
                                                inputValue: ["0"].includes(
                                                  _vm
                                                    .listItemsPaymentSchedule[0]
                                                    .status
                                                )
                                                  ? "-"
                                                  : _vm.formatDate(
                                                      _vm
                                                        .listItemsPaymentSchedule[0]
                                                        .nextDueDate
                                                    ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.listItemsPaymentScheduleDate &&
                            (_vm.listItemsPaymentSchedule[0].frequency ===
                              "0" ||
                              _vm.listItemsPaymentSchedule[0].frequency === 0)
                              ? _c("hr", { staticClass: "mx-auto" })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _vm.listItemsPaymentScheduleDate &&
                                (_vm.listItemsPaymentSchedule[0].frequency ===
                                  "0" ||
                                  _vm.listItemsPaymentSchedule[0].frequency ===
                                    0)
                                  ? _c(
                                      "form-accordion",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "mandate.scheduled_debit"
                                          ),
                                          isTitleUpperCase: false,
                                        },
                                      },
                                      [
                                        _vm.editMode &&
                                        (_vm.listItemsPaymentSchedule[0]
                                          .frequency === "0" ||
                                          _vm.listItemsPaymentSchedule[0]
                                            .frequency === 0) &&
                                        _vm.listItemsPaymentSchedule[0]
                                          .frequency !== ""
                                          ? _c(
                                              "div",
                                              { staticClass: "ml-5 mr-5" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-tertiary mb-4",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.addPaymentSchedule.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-plus",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.add_payment_date"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.list,
                                                  function (ps, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "rounded p-4 trackingAccordion mb-4",
                                                      },
                                                      [
                                                        _c(
                                                          "b-row",
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "form-write-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      inputLabel:
                                                                        _vm.$t(
                                                                          "mandate.amt"
                                                                        ) +
                                                                        " (€)",
                                                                      inputType:
                                                                        "number",
                                                                      isMandatory:
                                                                        "",
                                                                      disabled:
                                                                        !_vm.isEditable(
                                                                          ps
                                                                        ),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        ps.amount,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            ps,
                                                                            "amount",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "ps.amount",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "filter-item-title d-block mb-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "mandate.payment_schedule_date"
                                                                              )
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "red",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "*"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "datetime-picker-custom",
                                                                      {
                                                                        staticClass:
                                                                          "mr-3",
                                                                        class: {
                                                                          "filter-item-input": true,
                                                                          "filter-item-input-complete":
                                                                            ps.paymentScheduleDate,
                                                                        },
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "0.35rem",
                                                                          },
                                                                        attrs: {
                                                                          format:
                                                                            "YYYY-MM-DD",
                                                                          periodFull:
                                                                            "",
                                                                          id: "filter-datebegin",
                                                                          customInputParentClass:
                                                                            "filter-item-content",
                                                                          customInputClass:
                                                                            "w-100",
                                                                          maxLength: 19,
                                                                          placeholderValue:
                                                                            _vm.$t(
                                                                              "common.datepicker_format_date3"
                                                                            ),
                                                                          inputIcon:
                                                                            "fa-solid fa-calendar",
                                                                          disablePastDates:
                                                                            "",
                                                                          showTime: false,
                                                                          disabled:
                                                                            !_vm.isEditable(
                                                                              ps
                                                                            ),
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            ps.date,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                ps,
                                                                                "date",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "ps.date",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isEditable(ps)
                                                          ? _c(
                                                              "b-button",
                                                              {
                                                                staticClass:
                                                                  "btn btn-tertiary mt-3",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.removePaymentSchedule(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa-solid fa-trash",
                                                                }),
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.delete_payment_date"
                                                                      )
                                                                    ) +
                                                                    "\n                    "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : !_vm.editMode &&
                                            _vm.listItemsPaymentSchedule[0]
                                              .frequency !== "1"
                                          ? _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-striped w-50",
                                                staticStyle: {
                                                  margin: "0 auto",
                                                },
                                              },
                                              [
                                                _c(
                                                  "tbody",
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-center w-25",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.amt"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "text-center w-25",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "mandate.date_action"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.listItemsPaymentScheduleDate,
                                                      function (c) {
                                                        return _c(
                                                          "tr",
                                                          { key: c.date },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center w-25",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        c.amount
                                                                      ) || "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center w-25",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatDate(
                                                                        c.date
                                                                      ) || "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _vm.listItemsPaymentScheduleHistory.length >
                                  0 && !_vm.editMode
                                  ? _c(
                                      "form-accordion",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "Webheader.collections_list"
                                          ),
                                          isTitleUpperCase: false,
                                        },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-striped w-50",
                                            staticStyle: { margin: "0 auto" },
                                          },
                                          [
                                            _c(
                                              "tbody",
                                              [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("mandate.amt")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.date_due"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.date_debit"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "mandate.status_collection"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.listItemsPaymentScheduleHistory,
                                                  function (c) {
                                                    return _c(
                                                      "tr",
                                                      { key: c.date },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-center w-25",
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    c.Amount
                                                                  ) || "-"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-center w-25",
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatDate(
                                                                    c.DueDate
                                                                  ) || "-"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-center w-25",
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatDate(
                                                                    c.DebitDate
                                                                  ) || "-"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-center w-25",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                class: [
                                                                  "chip",
                                                                  "chip--" +
                                                                    _vm.statusVariant(
                                                                      c.Status
                                                                    ),
                                                                ],
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mandate.status_collection_" +
                                                                          c.Status
                                                                      ) || "-"
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !["0"].includes(_vm.listItemsPaymentSchedule[0].status)
                      ? _c(
                          "b-row",
                          {
                            staticClass: "form-group justify-content-end mt-5",
                          },
                          [
                            !_vm.editMode
                              ? _c(
                                  "b-col",
                                  { attrs: { lg: "2" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          size: "lg",
                                        },
                                        on: { click: _vm.toggleEditMode },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-pen-to-square",
                                          attrs: { size: "17px" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("mandate.edit"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.editMode
                              ? _c(
                                  "b-col",
                                  { attrs: { lg: "2" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "lg",
                                          variant: "primary",
                                        },
                                        on: {
                                          click: _vm.cancelPaymentSchedule,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-solid fa-xmark",
                                          attrs: { size: "17px" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("mandate.cancel"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.editMode
                              ? _c(
                                  "b-col",
                                  { attrs: { lg: "2", "offset-lg": "8" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          size: "lg",
                                        },
                                        on: { click: _vm.toggleEditMode },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-solid fa-xmark",
                                          attrs: { size: "17px" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("mandate.cancel"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.editMode
                              ? _c(
                                  "b-col",
                                  { attrs: { sm: "2" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          disabled: !_vm.isFormValid,
                                        },
                                        on: { click: _vm.editPaymentSchedule },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-paper-plane",
                                          attrs: { size: "17px" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("mandate.send"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.listItemsPaymentSchedule[0].status === "0" &&
                    _vm.listItemsPaymentSchedule[0].StatusMandate === "5"
                      ? _c(
                          "b-row",
                          {
                            staticClass: "form-group justify-content-end mt-5",
                          },
                          [
                            !_vm.editMode
                              ? _c(
                                  "b-col",
                                  { attrs: { lg: "2" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "lg",
                                          variant: "primary",
                                        },
                                        on: {
                                          click: _vm.activatePaymentSchedule,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-solid fa-check",
                                          attrs: { size: "17px" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("mandate.activate"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }